import React, { useState } from 'react';
import Select from 'react-select';
import './style.scss';

const SimpleSelect = ({ options, value, onChange, placeholder = 'Seleccionar...', isDisabled = false, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Select
      className={`${isOpen ? 'border-on ' : ''}`}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isDisabled={isDisabled}
      onMenuOpen={() => setIsOpen(true)}
      onMenuClose={() => setIsOpen(false)}
      loadingMessage={() => 'Cargando...'}
      noOptionsMessage={() => 'No hay opciones'}
      {...props}
    />
  );
};

export default SimpleSelect;